window.onscroll = function() {scrollNavigation()};

function scrollNavigation() {
    if (document.body.scrollTop > 10 || document.documentElement.scrollTop > 10) {
        document.getElementById("mainNav").classList.add('with-bg');
    } else {
        document.getElementById("mainNav").classList.remove('with-bg');
    }
}